import styled from 'styled-components';

export const StyledGalleryBatchLocationsRow = styled.div``;

export const StyledActionsWrap = styled.div`
  display: flex;
  align-items: center;
`;
